import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AppBarComponent, AppPageComponent, AppSidenavComponent } from "common";
import { AppBarDropdownComponent } from "@partner/shared/app-bar-dropdown/app-bar-dropdown.component";
import { SubmissionListComponent } from "./submission-list.component";
import { appBarData, appBarDropdownData } from "../../../../app.data";
import { AppPageResolver, AppSidenavItemsResolver } from "../../../../app.resolver";
import { OAuthGuard } from "../../../../../guards/oauth.guard";

const routes: Routes = [
  {
    path: "submissions",
    title: "Submissions – Idea Financial Partner",
    component: AppPageComponent,
    canActivate: [OAuthGuard],
    data: {
      appBar: appBarData(),
      appBarDropdown: appBarDropdownData(),
    },
    resolve: {
      appPage: AppPageResolver,
      appSidenav: AppSidenavItemsResolver,
    },
    children: [
      {
        path: "",
        outlet: "app-bar",
        component: AppBarComponent,
        children: [
          {
            path: "",
            outlet: "right",
            component: AppBarDropdownComponent,
          },
        ],
      },
      {
        path: "",
        outlet: "sidenav-content",
        component: AppSidenavComponent,
      },
      {
        path: "",
        component: SubmissionListComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SubmissionListRoutingModule { }
